import React from "react"
import { Switch, Route } from "react-router-dom"
import { injectIntl } from "react-intl"
import { withRouter } from "react-router"
import Landing from "../containers/landing"
import Rates from "../containers/rates"
import GetQuote from "../containers/get-quote"
import Renewal from "../containers/renewal"
import NewMortgage from "../containers/new-mortgage"
import Term from "../containers/terms"
import Privacy from "../containers/privacy"
import AboutuS from "../containers/about-us"
import FAQ from "../containers/faq"

const ComposedFAQ = withRouter(FAQ)
const ComposedLanding = withRouter(Landing)
const ComposedRates = withRouter(Rates)
const ComposedGetQuote = withRouter(GetQuote)
const ComposedNewMortgage = withRouter(NewMortgage)
const ComposedRenewal = withRouter(Renewal)
const ComposedTerm = withRouter(Term)
const ComposedPrivacy = withRouter(Privacy)
const ComposedAboutuS = withRouter(AboutuS)

const Routes = props => {
  return (
    <Switch>
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.faq" })}
        render={() => <ComposedFAQ {...props} />}
      />
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.home" })}
        render={() => <ComposedLanding {...props} />}
      />
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.rates" })}
        render={() => <ComposedRates {...props} />}
      />
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.get_quote" })}
        render={() => <ComposedGetQuote {...props} />}
      />
      <Route
        exact
        path={`${props.intl.formatMessage({
          id: "routes.calculator"
        })}/:page`}
        render={() => <ComposedNewMortgage {...props} />}
      />
      <Route
        exact
        path={`${props.intl.formatMessage({ id: "routes.reverse" })}/:page`}
        render={() => <ComposedRenewal {...props} />}
      />
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.terms" })}
        render={() => <ComposedTerm {...props} />}
      />
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.privacy" })}
        render={() => <ComposedPrivacy {...props} />}
      />
      <Route
        exact
        path={props.intl.formatMessage({ id: "routes.about_us" })}
        render={() => <ComposedAboutuS {...props} />}
      />
    </Switch>
  )
}

export default injectIntl(Routes)



// WEBPACK FOOTER //
// ./src/i18n/LocalizedRoutes.js